import React from 'react';
import TermsCondition from '../../../stories/components/OnboardingNew/PopUp/TermsCondition/TermsCondition';
import {useHistory} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';

import {
  ACCOUNT_CREATED_PAGE_URL,
  ACCOUNT_MANUAL_PAGE_URL,
  UPDATE_PAGE_URL,
} from '../../../constants';

import * as actions from '../../../store/actions/index';
import {
  tokenSelector,
  mobileSelector,
  nextLoader,
  errorSelector,
  nextScreenSelector,
} from '../../../store/selectors';
import {getCrid, updateUrlWithNewCrid} from '../../../../../myaccount/src/utils/redirectWithCrId';

const Terms = ({agreementType}) => {
  const history = useHistory();

  React.useEffect(() => {
    updateUrlWithNewCrid();
  }, []);

  const dispatch = useDispatch();

  const token = useSelector(tokenSelector);
  const error = useSelector(errorSelector);
  const setLoader = useSelector(nextLoader);
  const mobile = useSelector(mobileSelector);
  const nextScreen = useSelector(nextScreenSelector);
  const successCallback = screen => {
    // // campaign tracker gtag event call
    // // check campaign presence && if the function added in the base page is present to be sure, before calling
    // // short ciruit if not present, and call the function if all conditions are met
    // campaign !=='' && window.gtag_report_conversion !== undefined && window.gtag_report_conversion(window.location.href);
    // // Remove the local storage values, once the onboarding is done
    // removeItem("ref")
    // removeItem("cmp")
    // removeItem("token")
    // if (url !== '') {
    //   window.open(url, '_self');
    // } else {
    if (screen === 'verification') {
      history.push(`${ACCOUNT_CREATED_PAGE_URL}?crId=${getCrid()}`);
    } else if (screen === 'manual') {
      history.push(`${ACCOUNT_MANUAL_PAGE_URL}?crId=${getCrid()}`);
    }
    // }
  };

  const errorCallback = screen => {
    history.push(`${UPDATE_PAGE_URL}?crId=${getCrid()}`);
  };
  // const redirectToNext = () => {
  //   history.push(`${ACCOUNT_CREATED_PAGE_URL}`)
  // }

  const setPassword = data => {
    let fd = new FormData();
    fd.append('token', token);
    fd.append('agreed_time', data.userConsent);
    // redirectToNext();
    dispatch(actions.submitTnCAgree(fd, successCallback, errorCallback));
  };

  return (
    <TermsCondition
      apiError={error}
      mobileUser={mobile}
      setPassword={setPassword}
      setLoader={setLoader}
      agreement_type={agreementType}
    />
  );
};

export default Terms;
